export function isNotNull<T>(arg: T): arg is Exclude<T, null> {
    return arg !== null
}

export function isNotNumberArr(arg: [[number, number], [number, number]] | [number, number]): arg is [[number, number], [number, number]] {
    return typeof arg[0] === "object" && typeof arg[1] === "object";
}
